import React from 'react';
import { parseDate } from '@frontend/jetlend-core/src/formatters/formatUtils';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import Link from 'next/link';
import { INewsTagApiModel } from '@app/models/features/news';
import styles from './NewsCard.module.scss';
import SectionPart from '@app/ui/SectionPart/SectionPart';
import Image from '@app/components/Image/Image';
import HtmlMarkup from '@app/components/HtmlMarkup/HtmlMarkup';
import { formatTextWithNumbers } from '@app/utils/formatTextWithNumbers';

interface IProps {
    postSlug: string;
    title: string;
    description: string;
    url?: string;
    image: string;
    /**
     * Текст alt тега изображения
     */
    imageAlt?: string;
    tags: INewsTagApiModel[];
    date: string;
    type?: 'default' | 'long';
}

const getDescriptionWithEnding = (description: string) => {
    const exceptions = ['.', '!', '?'];
    const lastCharExceptions = ['—', '-'];

    if (!description) {
        return '';
    }

    const lastDescriptionChar = description[description.length - 1];

    if (exceptions.includes(lastDescriptionChar)) {
        return description;
    }

    if (lastCharExceptions.includes(lastDescriptionChar)) {
        return `${description.slice(0, description.length - 2)}...`;
    }

    return `${description}...`;
};

export default function NewsCard({
    url,
    title,
    description,
    date,
    type,
    image,
    imageAlt,
}: IProps) {

    const descriptionWithEnding = getDescriptionWithEnding(description);

    const cardClassNames = buildClassNames(styles, [
        'card',
        `card__${type || 'default'}`,
    ]);

    const content = (
        <SectionPart className={cardClassNames}>
            <div className={styles['card__image-wrapper']}>
                <Image
                    src={image}
                    alt={imageAlt ?? ''}
                    fill
                    className={styles['card__image']}
                />
            </div>
            {/* {props.tags && props.tags.length > 0 && (
                    <div className={styles['card__tags']}>
                        {props.tags.map(tag => (
                            <NewsTag
                                key={tag.id}
                                id={tag.id}
                                title={tag.title}
                                slug={tag.slug}
                                url={tag.url}
                            />
                        ))}
                    </div>
                )} */}
            <div className={styles['card__text']}>
                <HtmlMarkup
                    tag="div"
                    className={styles['card__text-title']}
                    markup={formatTextWithNumbers(title)}
                />
                <HtmlMarkup
                    tag="div"
                    className={styles['card__text-description']}
                    markup={descriptionWithEnding}
                />
                <p className={styles['card__text-date']}>{parseDate(date).format('DD / MM / YYYY')}</p>
            </div>
        </SectionPart>
    );

    if (url) {
        return (
            <Link href={url} style={{ textDecoration: 'none' }}>
                {content}
            </Link>
        );
    }

    return content;
};
